var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Switchboard } from "../../../lib/events";
import { SelectableLayer } from "../../../lib/layers";
import { Observable, Refresh } from "../../../lib/misc/decorators";
export let ParcelLayer = class ParcelLayer extends SelectableLayer {
    constructor(opts) {
        super(opts);
        this.thematic_receiver = Switchboard.get_receiver("THEMATIC");
        this.thematic_emitter = Switchboard.get_emitter("THEMATIC");
        this.thematic_receiver.on('action', (visible_count) => {
            if (visible_count === 0)
                return;
            this.use_base_style();
        });
    }
    use_base_style() {
        this.colorized = false;
        this.color_manager.ui.hide_legend();
        this.update_style('default');
    }
    use_colorized_style() {
        this.thematic_emitter.emit("thematic_select", "NONE");
        this.colorized = true;
        const discernable = this.color_manager.strategy.isSomeAnd((strategy) => strategy.has_legend);
        this.update_style('colorized', discernable);
    }
    start_colorize() {
        this.color_manager.load_features(this.features);
        $('#colorize-confirm').on('click', () => this.finish_colorize());
        $('#colorize-cancel').on('click', () => this.cancel_colorize());
        $('#colorize-remove').on('click', () => {
            this.cancel_colorize();
            this.use_base_style();
        });
    }
    cancel_colorize() { this.color_manager.hide(); }
    finish_colorize() {
        this.color_manager.hide();
        this.colorize_current_parcels();
        this.color_manager.populate_legend();
    }
    colorize_current_parcels() {
        this.color_manager.colorize(this.features);
        this.use_colorized_style();
    }
};
__decorate([
    Refresh
], ParcelLayer.prototype, "use_base_style", null);
__decorate([
    Refresh
], ParcelLayer.prototype, "use_colorized_style", null);
__decorate([
    Refresh
], ParcelLayer.prototype, "colorize_current_parcels", null);
ParcelLayer = __decorate([
    Observable
], ParcelLayer);
